import React, { useEffect, useRef, Fragment } from "react";
import { matchPath } from "react-router";
import * as R from "ramda";

const asyncUrl = `pixel-a.basis.net/dmp/asyncPixelSync`;

export const Pixel = ({ url }) => {
  return <img alt="Pixel Tracker" src={`//${url}`} style={{ height: 0 }} />;
};

export const Iframe = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.contentWindow) {
      const doc = ref.current.contentWindow.document;
      doc.open().write(`<body onload="window.location.href='//${asyncUrl}'">`);
      doc.close();
    }
  }, []);

  return (
    <iframe
      ref={ref}
      src={"javascript: false;"}
      style={{
        width: 0,
        height: 0,
        border: 0,
      }}
    />
  );
};

const PixelTracker = ({ locationPathname, trackers }) => {
  const pixelUrls = R.pipe(
    R.prop("edges"),
    R.map(R.prop("node"))
  )(trackers);

  return (
    <Fragment>
      {R.map(({ id, localPath, remoteUrl }) => {
        const shouldTrack = matchPath(locationPathname, {
          path: localPath,
          exact: true,
        });
        return shouldTrack ? <Pixel key={id} url={remoteUrl} /> : null;
      }, pixelUrls)}
      <Iframe />
    </Fragment>
  );
};

export default PixelTracker;

export const TrackerQuery = graphql`
  fragment TrackerQuery on RootQueryType {
    allContentfulTracker(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          ...TrackerFragment
          node_locale
        }
      }
    }
  }

  fragment TrackerFragment on ContentfulTracker {
    id
    __typename
    localPath
    remoteUrl
  }
`;



// WEBPACK FOOTER //
// ./src/components/PixelTracker.js